import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar'
import Hero2 from '../../components/hero2/hero2';
import CoupleSection from '../../components/CoupleSection/CoupleSection';

import PortfolioSection from '../../components/PortfolioSection';
import EventSection from '../../components/EventSection/EventSection';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar'
import vImg from '../../images/video-img/img-1.jpg'
import VideoSection from '../../components/VideoSection';



const HomePage = () => {

    return (
        <Fragment>
            <Navbar />
            <Hero2 />
            <EventSection />
            <CoupleSection />
            <PortfolioSection />
            <VideoSection vimg={vImg} />
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};

export default HomePage;